<template functional>
    <div v-if="props.error === 401 || props.error === 403">
        <h1>Forbidden</h1>
        <p>You are not authorised to view this page.</p>
    </div>
    <div v-else-if="props.error === 404">
        <h1>404 Not Found</h1>
        <p>The requested content could not be found.</p>
    </div>
    <div v-else>
        <h1>Error</h1>
        <p>We're sorry, an unknown error occured. Please contact us if this persists.</p>
    </div>
</template>

<script>
export default {
    name: 'Forbidden',
    props: {
        error: {
            type: Number,
            default: 400
        }
    }
};
</script>

<style lang="scss">

</style>
